export class Supplier {
    id: string;
    name: string;
    status: string;
    max_debit: string;
    address: string;
    manager_name: string;
    mobile: string;
    tel: string;
    fax: string;
    email: string;
  tax_classification: string;
  tax_number: string;
    row_id: string;
    creation_user: string;
    creation_ip: string;
    created_at: string;
    showDeletedOnly: boolean;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/suppliers/supplier.ts